module.exports = __webpack_public_path__ + "static/cat-28cf88342c99207638f7986e2c58e79d.svg";